// Factures proforma (devis) : liste et suivi.
import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Card, CardContent, Chip, Grid, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography,
} from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { clientAPI, proformaAPI } from '../services/api';
import { apiError, dateFr, fcfa, PROFORMA_STATUS } from '../utils/format';
import { tokens } from '../theme';

const Proformas = () => {
  const { canCompta } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ proformas: [], resume: null });
  const [clients, setClients] = useState([]);
  const [filters, setFilters] = useState({ statut: '', client_id: '' });
  const [error, setError] = useState('');

  useEffect(() => { clientAPI.list(true).then((r) => setClients(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const p = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    proformaAPI.list(p).then((r) => setData(r.data)).catch((e) => setError(apiError(e)));
  }, [filters]);

  const r = data.resume;
  return (
    <Layout title="Proformas (devis)" plain
      actions={canCompta && <Button variant="contained" startIcon={<AddOutlined />} onClick={() => navigate('/proformas/nouvelle')}>Nouvelle proforma</Button>}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {r && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {[['Offres en cours (TTC)', `${fcfa(r.en_cours_ttc)} F`], ['Proformas en cours', r.nb_en_cours], ['Acceptées', r.nb_acceptees],
            ['Taux de transformation', r.taux_transformation === null ? '—' : `${r.taux_transformation} %`]].map(([l, v]) => (
            <Grid item xs={6} md={3} key={l}><Card variant="outlined"><CardContent sx={{ py: '12px !important' }}>
              <Typography variant="body2" color="text.secondary">{l}</Typography>
              <Typography sx={{ fontFamily: tokens.mono, fontSize: 22, fontWeight: 600 }}>{v}</Typography>
            </CardContent></Card></Grid>
          ))}
        </Grid>
      )}
      <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
        <TextField select size="small" label="Statut" value={filters.statut} sx={{ minWidth: 180 }} onChange={(e) => setFilters({ ...filters, statut: e.target.value })}>
          <MenuItem value="">Tous</MenuItem>
          {Object.entries(PROFORMA_STATUS).map(([k, v]) => <MenuItem key={k} value={k}>{v.label}</MenuItem>)}
        </TextField>
        <TextField select size="small" label="Client" value={filters.client_id} sx={{ minWidth: 220 }} onChange={(e) => setFilters({ ...filters, client_id: e.target.value })}>
          <MenuItem value="">Tous</MenuItem>
          {clients.map((c) => <MenuItem key={c.id} value={c.id}>{c.nom}</MenuItem>)}
        </TextField>
      </Box>
      <Card variant="outlined">
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Numéro</TableCell><TableCell>Date</TableCell><TableCell>Valable jusqu'au</TableCell><TableCell>Client</TableCell>
                <TableCell>Objet</TableCell><TableCell align="right">Remise</TableCell><TableCell align="right">Total TTC</TableCell><TableCell>Statut</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.proformas.map((p) => (
                <TableRow key={p.id} hover sx={{ cursor: 'pointer' }} onClick={() => navigate(`/proformas/${p.id}`)}>
                  <TableCell sx={{ fontFamily: tokens.mono, fontWeight: 600, whiteSpace: 'nowrap' }}>{p.numero || '—'}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{dateFr(p.date_proforma)}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap', color: p.expiree ? 'error.main' : undefined }}>{dateFr(p.date_validite)}</TableCell>
                  <TableCell>{p.client_affiche}</TableCell>
                  <TableCell sx={{ maxWidth: 280 }}>{p.objet}</TableCell>
                  <TableCell align="right">{p.remise_pct ? `${String(p.remise_pct).replace('.', ',')} %` : ''}</TableCell>
                  <TableCell align="right" sx={{ fontFamily: tokens.mono, whiteSpace: 'nowrap' }}>{fcfa(p.total_ttc)}</TableCell>
                  <TableCell>
                    <Chip size="small" label={PROFORMA_STATUS[p.statut].label} color={PROFORMA_STATUS[p.statut].color} />
                    {p.expiree && <Chip size="small" label="Expirée" color="warning" variant="outlined" sx={{ ml: 0.5 }} />}
                    {p.invoice_numero && <Box sx={{ fontSize: 11.5, color: 'text.secondary', mt: 0.25 }}>{p.invoice_numero}</Box>}
                  </TableCell>
                </TableRow>
              ))}
              {data.proformas.length === 0 && <TableRow><TableCell colSpan={8} align="center" sx={{ py: 3 }}>Aucune proforma</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Layout>
  );
};

export default Proformas;
